import { z } from 'zod';
import { AuthProviderSchema, OrgRoleSchema, PrincipalSchema, UlidSchema } from './common';

export const MeSchema = z.object({
  user: z.object({
    id: UlidSchema,
    email: z.string().nullable(),
    displayName: z.string(),
    avatarUrl: z.string().nullable(),
    createdAt: z.number().int(),
  }),
  identities: z.array(
    z.object({
      provider: AuthProviderSchema,
      email: z.string().nullable(),
      emailVerified: z.boolean(),
    }),
  ),
  orgs: z.array(
    z.object({
      orgId: z.string(),
      slug: z.string(),
      name: z.string(),
      roles: z.array(OrgRoleSchema),
    }),
  ),
  principal: PrincipalSchema,
});
export type Me = z.infer<typeof MeSchema>;
